import type { Ayah } from '@app-types/KuranTypes'
import type { PageType } from '@app-types/PageType'
import { CevsenCompact } from '@components/DuaPage/CevsenCompact'
import DuaPageComponent, { type DuaPartType } from '@components/DuaPage/DuaPageComponent'
import KuranPageComponent from '@components/Kuran/KelimeMealliPage/KuranPage'
import type { PageData } from '@components/shared/PageInfoRow/PageInfoRow'
import type { FC } from 'react'

export type ReaderContentProps =
  | {
      kind: 'quran'
      page: string
      ayahs: Ayah[]
      pageData: PageData
      mobileReader?: boolean
      showSoundPlayer?: boolean
    }
  | {
      kind: 'dua'
      type: PageType
      page: number
      data: DuaPartType[]
    }
  | {
      kind: 'cevsen'
      page: number
      data: Record<string, DuaPartType[]>
    }

/** Shared reader content used by browser routes and the native WebView shell. */
const ReaderContent: FC<ReaderContentProps> = (props) => {
  if (props.kind === 'quran') {
    return <KuranPageComponent {...props} />
  }

  if (props.kind === 'dua') {
    return <DuaPageComponent type={props.type} data={props.data} page={props.page} />
  }

  return <CevsenCompact page={props.page} data={props.data} />
}

export default ReaderContent
